// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';
import type { IClaimDto } from './IClaimDto';
import {
    IClaimDtoFromJSON,
    IClaimDtoFromJSONTyped,
    IClaimDtoToJSON,
    IClaimDtoToJSONTyped,
} from './IClaimDto';

/**
 * 
 * @export
 * @interface IPageClaimDto
 */
export interface IPageClaimDto {
    /**
     * 
     * @type {number}
     * @memberof IPageClaimDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageClaimDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageClaimDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IClaimDto>}
     * @memberof IPageClaimDto
     */
    content?: Array<IClaimDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageClaimDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageClaimDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageClaimDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageClaimDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageClaimDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageClaimDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageClaimDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageClaimDto interface.
 */
export function instanceOfIPageClaimDto(value: object): value is IPageClaimDto {
    return true;
}

export function IPageClaimDtoFromJSON(json: any): IPageClaimDto {
    return IPageClaimDtoFromJSONTyped(json, false);
}

export function IPageClaimDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageClaimDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IClaimDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageClaimDtoToJSON(json: any): IPageClaimDto {
    return IPageClaimDtoToJSONTyped(json, false);
}

export function IPageClaimDtoToJSONTyped(value?: IPageClaimDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IClaimDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

